module.exports = {"542427100":"亚拉镇","542427101":"荣布镇","542427200":"若达乡","542427201":"热瓦乡","542427202":"西昌乡","542427203":"嘎木乡","542427204":"赤多乡","542427205":"嘎美乡","542427206":"加勤乡","542427207":"江达乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542427.json
// module id = 2557
// module chunks = 0